import { Box, Typography, useTheme } from '@mui/material';
import { FormattedMessage } from 'react-intl';

const PAGE_NAME_ID = 'orderFeed.ofdMySupplyPlan.inputSettings.feedReserveTab';

const LineDescription = () => {
  const theme = useTheme();

  return (
    <>
      <Box>
        <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'} mt={2} p={theme.spacing(0, 2, 0, 0)}>
          <Typography fontSize={10} mr={2}>
            <FormattedMessage id={`${PAGE_NAME_ID}.adaptiveBufferTitel`} />
            (<FormattedMessage id={`${PAGE_NAME_ID}.days`} />
            ):
          </Typography>
          <Box>
            <Box width={40} sx={{ borderTop: 'dashed black 1px' }}></Box>
          </Box>
        </Box>
      </Box>
      <Box>
        <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'} mt={2} p={theme.spacing(0, 2, 0, 0)}>
          <Typography fontSize={10} mr={2}>
            <FormattedMessage id={`${PAGE_NAME_ID}.staticBuffer`} />
            (%):
          </Typography>
          <Box>
            <Box width={40} sx={{ borderTop: 'solid black 1px' }}></Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default LineDescription;
